<div
  class="moulding-node"
  [class.moulding-node--selected]="selected"
  [class.moulding-node--editing]="editingName"
>
  <div class="moulding-node__toolbar" role="toolbar" aria-label="Node actions">
    @if (processingNodeKind) {
      <span
        [pTooltip]="
          processing.downstreamExecutionActive()
            ? 'Downstream steps are running. Wait for the sequence to finish.'
            : (processingNodeStartError ?? processingNodeActionLabel)
        "
        tooltipPosition="top"
      >
        <button
          class="moulding-node__icon-btn"
          type="button"
          [class.moulding-node__icon-btn--primary]="canStartProcessingNode"
          [disabled]="!canStartProcessingNode"
          [title]="
            processing.downstreamExecutionActive()
              ? 'Downstream steps are running. Wait for the sequence to finish.'
              : (processingNodeStartError ?? processingNodeActionLabel)
          "
          (pointerdown)="$event.stopPropagation()"
          (click)="onStartProcessingNode($event)"
        >
          <i
            [class]="
              processingNodeActionLabel === 'Restart step'
                ? 'pi pi-refresh'
                : 'pi pi-play'
            "
          ></i>
        </button>
      </span>
    }
    <button
      class="moulding-node__icon-btn"
      type="button"
      title="Rename node"
      pTooltip="Rename node"
      tooltipPosition="top"
      (pointerdown)="$event.stopPropagation()"
      (click)="beginNameEdit($event)"
    >
      <i class="pi pi-pencil"></i>
    </button>
    <button
      class="moulding-node__icon-btn"
      type="button"
      title="Delete node"
      pTooltip="Delete node"
      tooltipPosition="top"
      (pointerdown)="$event.stopPropagation()"
      (click)="onDelete($event)"
    >
      <i class="pi pi-trash"></i>
    </button>
  </div>
  <div class="moulding-node__header">
    @if (editingName) {
      <input
        class="moulding-node__name-input"
        type="text"
        [value]="nodeNameDraft"
        maxlength="255"
        aria-label="Node name"
        (pointerdown)="$event.stopPropagation()"
        (input)="updateNodeNameDraft($event)"
        (keydown.enter)="saveNodeName($event)"
        (keydown.escape)="cancelNameEdit($event)"
      />
      <div class="moulding-node__name-actions">
        <button
          class="moulding-node__icon-btn"
          type="button"
          title="Save node name"
          pTooltip="Save node name"
          tooltipPosition="top"
          (pointerdown)="$event.stopPropagation()"
          (click)="saveNodeName($event)"
        >
          <i class="pi pi-check"></i>
        </button>
        <button
          class="moulding-node__icon-btn"
          type="button"
          title="Cancel rename"
          pTooltip="Cancel rename"
          tooltipPosition="top"
          (pointerdown)="$event.stopPropagation()"
          (click)="cancelNameEdit($event)"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
    } @else {
      <span class="moulding-node__title">{{ data.label }}</span>
    }
  </div>

  <div
    class="moulding-node__body"
    role="button"
    tabindex="0"
    [attr.aria-label]="'Configure ' + data.label"
    (pointerdown)="$event.stopPropagation()"
    (click)="onNodeBodyClick($event)"
    (keydown)="onNodeBodyKeydown($event)"
  >
    <div class="moulding-node__summary">
      {{ nodeSummary }}
      @if (isOutdated) {
        <i
          class="pi pi-exclamation-triangle text-xs text-orange-500 cursor-pointer"
          pTooltip="Step Outdated - Upstream input changed."
          tooltipPosition="top"
          role="img"
          aria-label="Step Outdated - Upstream input changed."
        ></i>
      }
    </div>

    <ng-content select="[node-ports]" />
  </div>
</div>
